import logoImage from "public/images/knicks/knicks-mock-logo.png";
import { routes } from "src/shared/routes";
import { TTeamConfig } from "src/shared/types/teamConfig.types";
import {
  AnalyticsHeader,
  FAQS,
  TERMS_AND_CONDITION,
  TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
  TERMS_AND_CONDITION_ADD_ON,
} from "./helper";

export const sacramentokings_sandbox: TTeamConfig = {
  TEAM_SCHEMA: "sacramentokings_sandbox",
  TEAM_FULL_NAME: "Sacramento Kings",
  BROWSER_TITLE: "Sacramento Kings",
  CLIENT_ID: "6b6c129ee955.seasonshare.sackings-sackings.us",

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#5b2c81",
    COLORS_SECONDARY: "#63727A",
    LOGOUT_ON_INVALID_SESSION: false,
    IS_INTERCOM_ENABLED: true,
    DEFAULT_APP_ROUTE: routes.landing,
    ANALYTICS_HEADER: AnalyticsHeader,
  },

  LANDING_PAGE_SETTINGS: {
    SHOW_ALL_PASSES_UNDER_BANNER: true,
    HIDE_UPCOMING_EVENTS: true,
    PASS_BANNER: {
      HIDE_PASS_DETAILS: true,
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL:
      "https://ss-leagues.s3.amazonaws.com/NCAA/Kings-Primary-Color_Logo.png",
    ORDER_SUMMERY_BACKGROUND_URL:
      "https://ss-leagues.s3.amazonaws.com/NBA 2024-25/kings-v3-assets/BACKGROUND IMAGE_1.jpg",
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
    TERMS_AND_CONDITION_OPT_OUT_RESTRICTED,
    TERMS_AND_CONDITION_ADD_ON,
  },
};
